// extracted by mini-css-extract-plugin
export default {"regroupRuleContainer":"IssueRegroup__regroupRuleContainer__O9NkL"};